"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnEntityRemoved = void 0;
/**
 * @public
 * Emitted on entity removed from plot, if the entity is not present this is not emitted.
 */
class OnEntityRemoved {
    constructor(onEntityRemoved) {
        this.onEntityRemoved = onEntityRemoved;
    }
    static registerListener(owner, onEvent) {
        return owner.eventService
            .getCategory(OnEntityRemoved)
            .addTemporaryListener(new OnEntityRemoved(onEvent));
    }
    static registerOneTimeListener(owner, onEvent) {
        return owner.eventService
            .getCategory(OnEntityRemoved)
            .addOneTimeListener(new OnEntityRemoved(onEvent));
    }
    static emit(eventService, entity) {
        const listeners = eventService
            .getCategory(OnEntityRemoved)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onEntityRemoved(entity);
        }
    }
}
exports.OnEntityRemoved = OnEntityRemoved;
OnEntityRemoved.callbackKey = "onEntityRemoved";
//# sourceMappingURL=on-entity-removed.js.map